import React from 'react';
import { Link } from 'react-router';

const Header = (props) => {
  return (
    <header id="header">
      <h1 id="logo">
        <Link to="/">
          <img src="images/miranda-logo-header.png" alt="Soares de Miranda e André" />
        </Link>
      </h1>
      <nav id="nav">
        <ul>
          <li>
            <Link to="/">
              Voltar à página inicial
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/HeaderGallery.js